import API from '../utils/api';
import { ENDPOINT_URL } from '../constants/defaultValues';

const getAppVersion = async () => {
    try {
        const res = await API.get(`${ENDPOINT_URL}/versions/ssbt`);

        return res.data;
    } catch (error) {
        console.error(error);
        return { info: { success: false } };
    }
};

const AppVersionsService = {
    getAppVersion,
};

export default AppVersionsService;
